import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux-stores/store';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchInvitedCampaignsThunk } from '../../redux-stores/slices/campaignSlice';
import ClickableImage from '../misc/ClickableImage';
import CampaignSkeleton from '../../skeletons/CampaignSkeleton';
const InvitedCampaigns = () => {

    const { list, loading } = useSelector((state: RootState) => state.campaigns.invited)

    const dispatch: AppDispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchInvitedCampaignsThunk())
    }, [])

    if(list.length === 0) return null;

    return (
        <div className='invited-campaigns mb-3 mt-0'>
            <h4 className="sponsorships-title pop">
                Campaign Invites
            </h4>
            <Swiper pagination={true} autoplay={true} loop={true} modules={[Pagination, Autoplay]} className="mySwiper">
                {
                    list.map((campaign, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <div className="card card-style mb-3">
                                    <ClickableImage imageURL={campaign.hero_img_url} path={`/campaign/${campaign.uuid}`}
                                        rounded={false}
                                    />
                                    <div className="invited-campaign-name">
                                        <h4 className='w-100 text-truncate'>{campaign.name}</h4>
                                    </div>
                                </div>
                            </SwiperSlide>
                        )
                    })
                }
                {
                    loading && <CampaignSkeleton />
                }
            </Swiper>
        </div>
    )
}

export default InvitedCampaigns